import $ from 'jquery';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseBannerModel } from 'app/model/banner/banner';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { BannerService } from 'app/services/banner/banner.service';
import { UserService } from 'app/services/user/user.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-banner-billboard',
  templateUrl: './banner-billboard.component.html',
  styleUrls: ['./banner-billboard.component.scss']
})
export class BannerBillboardComponent implements OnInit, OnDestroy {
  public isMobile;
  public lang;
  public billboards: BaseBannerModel[] = [];
  public bannerType = 'billboard';

  private getBannerBillboardSubscription: Subscription;
  private languageSubscription: Subscription;

  constructor(
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService,
    private userService: UserService,
    private bannerService: BannerService,
  ) {
    this.isMobile = this.utilitiesService.isMobile();
    this.lang = this.appConfigService.getLanguage();
  }

  ngOnInit() {
    this.fetchBillboard();
    this.languageSubscription && this.languageSubscription.unsubscribe();
    this.languageSubscription = this.appConfigService.getLanguageObs()
      .subscribe((val) => {
        if (this.lang !== val) {
          this.lang = val;
          this.fetchBillboard();
        }
      });
  }

  ngOnDestroy() {
    this.getBannerBillboardSubscription && this.getBannerBillboardSubscription.unsubscribe();
  }

  initCarousel() {
    setTimeout(() => {
      const owlCarousel = $('.billboard-owl');
      if (owlCarousel && owlCarousel.children().length === this.billboards.length) {
        owlCarousel.owlCarousel({
          loop: true,
          margin: 10,
          nav: false,
          items: 1,
          autoplay: true,
          autoplayTimeout: 5000,
          autoplayHoverPause: true
        });
      } else {
        this.initCarousel();
      }
    });
  }

  fetchBillboard() {
    this.billboards = [];
    const companyId = this.userService.getUser().companyId;
    this.getBannerBillboardSubscription && this.getBannerBillboardSubscription.unsubscribe();
    this.getBannerBillboardSubscription = this.bannerService.getBannerBillboard(companyId, this.lang, this.isMobile ? 'mobile' : 'desktop')
      .subscribe((res) => {
        this.billboards = res;
        this.initCarousel();
      }, (err) => {
        console.error(err);
        this.billboards = [];
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/banner-billboard/banner-billboard.component.ts